<template>
    <div class="container mt-5">
      <header id="page-topbar" style="background-color: #03806a;text-emphasis-color: white;" >
        <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <router-link tag="a" to="" class="logo">
            <span class="logo-sm">
              <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
              <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
            </span>
            <span class="logo-lg">
              <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
              <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
            </span>
          </router-link>
        </div>
        <span toggle-class="header-item" class="pt-3 d-none d-lg-block">
          <span class="h3 text-white"> <b>{{ userData.business }}</b> </span> <br>
          <small class="me-3 text-white"><i class="fas fa-map-marker-alt"></i> {{ userData.location }} </small>
          <small class="text-white"><i class="fas fa-phone-alt"></i> {{ userData.contact }} </small>
        </span>
      </div>

      <div class="d-flex">
        <b-dropdown right variant="white" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle text-white mdi-24px"></i>
            <span class="d-none d-xl-inline-block text-white mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>Logout</a>
        </b-dropdown>
      </div>
    </div>
  </header>
  <br><br>
  <div class="alert alert-warning text-center p-5" style="border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
    <h1 class="fw-bold mb-4" style="color: #d9534f;">Action Required!</h1>
    <h4 class="mb-3">Billing Suspension for Your Pharma Tech  Subscription</h4>
    <p class="mb-4" style="color:#000;">
        Your subscription is currently suspended due to non-payment. All services for all users are currently unavailable.
    </p>
    <p class="mb-6" style="color:#000;">
        To restore your access, please make your payment by clicking the button below.
    </p>
    <router-link to="/payments" class="btn btn-primary btn-lg mb-4" style="padding: 10px 20px; font-size: 18px;">Make Payment</router-link>
    <p class="mt-3" style="color:#000;">
        Sincerely,<br>
        <strong>The Afrimed Team</strong>
    </p>
</div>
  
    </div>
  </template>
  
  <script>
import axios from "axios";
// import Layout from "../../layouts/auth";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { subscriptionMethods, subscriptionComputed } from "@/state/helpers";

export default {
  page: {
    name: "LicenseExpired",
    title: "Subscriptions",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  // components: {
  //   PageHeader
  // },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Subscriptions",
      items: [  {text: "Subscriptions",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'service', label: 'Service', visible: true },
          { key: 'amount', label: 'Amount', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'updated_at', label: 'Paid On', visible: true },
        ],
      id:'',
      name:'',
      services:["Software Subscription","SMS Purchase"], service:"",
      products:[], product:"", amount:"",telephone:"", responseMessage:"", 
      options : { weekday: "short", year: "numeric", month: "long", day: "numeric", hour: 'numeric'},
    };
  },
  computed: {
    ...subscriptionComputed,
    List() { return this.subscriptions.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.subscriptions.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.subscriptions.length>0) { a=false;} else { a=true;} return a },
  },
  
  mounted() {
    this.TotalRows = this.subscriptions.length;
    this.isBusy=false;
  },
  methods: {
    ...subscriptionMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    
   

   
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>
 
  
  <style scoped>
  .alert {
    margin-top: 50px;
  }
  </style>
  